import { useEffect } from "react";
import type { ReactNode } from "react";

import { disposeTelegram, initTelegram } from "@/shared/telegram";

/**
 * Поднимает Telegram SDK один раз на всё приложение. Провал инициализации —
 * не ошибка: приложение открыто в обычном браузере, и в dev оно должно
 * продолжать работать (вход даёт `make dev-initdata`).
 */
export function TelegramProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    initTelegram();
    return () => {
      disposeTelegram();
    };
  }, []);

  return children;
}
